<mat-card class="org-mat-tab-card">
  <!-- Fancy tile navigation for organization management -->
  <div class="org-header">
    <h2 class="org-title">Organization Management</h2>
    <p class="org-subtitle">Manage organizations, sub-organizations, settings and users</p>
  </div>
  <div class="org-tile-grid">
    <ng-container *ngFor="let tab of orgTabs; let i = index">
      <ng-container *ngIf="tab.permission && authService.hasPermission && authService.hasPermission(tab.permission)">
        <div class="org-tile" 
             [class.active]="selectedTabIndex === i" 
             [class.blurred]="!organizationCreated && i !== 0"
             (click)="onTabChange(i)"
             [attr.tabindex]="!organizationCreated && i !== 0 ? -1 : 0"
             [attr.aria-disabled]="!organizationCreated && i !== 0"
             [attr.data-testid]="'org-tile-' + tab.route">
          <div class="org-tile-icon">
            <mat-icon>{{ tab.icon }}</mat-icon>
          </div>
          <div class="org-tile-content">
            <div class="org-tile-title">{{ tab.label }}</div>
            <div class="org-tile-desc">{{ tab.desc }}</div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <router-outlet></router-outlet>
</mat-card>